@if (apiRoot | async; as _apiRoot) {
	<div class="c-areas" data-test-id="dashboard" data-help-anchor="_dashboards" (keydown)="moveFocus($event)">
		@if ((_apiRoot | hasResourceLink: 'vorgaengeInRuecklauf') && (vorgaengeInRuecklauf | async); as _vorgaenge) {
			<schir-int-client-ruecklauf class="c-areas__area" [headline]="isLFPR ? 'Geschäftsstelle' : 'Rücklauf'"
			                            [vorgaenge]='_vorgaenge'/>
		}

		@if ((_apiRoot | hasResourceLink: 'vorgaengeFuerRechtspfleger') && (vorgaengeForRechtspflege | async); as _vorgaenge) {
			<schir-int-client-eingang-list class="c-areas__area" [headline]="isLFPR ? 'Rechtspflege' : 'Eingänge'" [icon]="'email'"

			                               [vorgaenge]="_vorgaenge"/>
		}

		@if ((_apiRoot | hasResourceLink: ApiRootLinkRel.VORGAENGE_IN_WIEDERVORLAGE)) {
			<schir-int-client-wiedervorlage-list class="c-areas__area"
			/>
		}
	</div>
}
